import { Theme, useMediaQuery } from "@mui/material";
import { Fragment } from "react";
import { TextField, DatagridConfigurable, List, SearchInput, useListContext, TopToolbar, FilterButton, SortButton, useGetResourceLabel, TextInput, BooleanInput, DateInput } from "react-admin";
import MobileGrid from "./MobileGrid";
import { defaultSacopExporter, standardSacopExporter } from "../../../../shared/utilities/sacopExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <SortButton fields={['dateRequestAction']} />
        <FilterButton />
        <SacopExportButton exporter={standardSacopExporter} />
    </TopToolbar>
);

const sectorFilters = [
    <SearchInput source="q" alwaysOn />,
    <DateInput source="dateRequestAction" />, 
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return (
        <Fragment>
            {(!isXSmall ? (
                <MobileGrid  {...listContext} />
            ) : (
                <DatagridConfigurable rowClick="edit" >
                    <TextField source="dateRequestAction" />
                </DatagridConfigurable>)
            )
            }
        </Fragment>
    );
}

const AnalysisOfSharesList = () => {
    return (<List
        // filterDefaultValues={ { active: true }}
        sort={{ field: 'dateRequestAction', order: 'DESC' }}
        perPage={25}
        filters={sectorFilters}
        actions={<ListActions />}
        exporter={standardSacopExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default AnalysisOfSharesList;

